import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import { CARAT_COLOUR_LIST } from "assets/properties/properties";
import { CARAT_CLARITY_LIST } from "assets/properties/properties";
import { getDiamondAmount } from "../OrnamentV2Api";
import { useSelector } from "react-redux";
const DiamondLoanField = ({
  handleChange,
  groupDetails,
  classes,
  toastUpdate,
  setGroupDetails,
  currentIndex,
  isAuditFlagTrue,
  checkValidationForNewPacket,
}) => {
  const { authToken } = useSelector((state) => state.login.authData);
  const [diamondRate, setDiamondRate] = useState({});
  const groupDetailsCurrentObj = groupDetails?.[currentIndex];

  useEffect(() => {
    const fetchDiamondRate = async () => {
      const { caretColor, caretGrade } = groupDetailsCurrentObj || {};

      if (!caretColor || !caretGrade) {
        setDiamondRate([]);
        return;
      }

      try {
        const result = await getDiamondAmount(
          caretColor,
          caretGrade,
          authToken
        );

        if (result?.length > 0) {
          setDiamondRate(result);
        } else {
          setDiamondRate([]);

          // Clear caret color, caret grade, and diamond rate
          setGroupDetails((prev) =>
            prev.map((item, i) =>
              i === currentIndex
                ? {
                    ...item,
                    caretColor: "",
                    caretGrade: "",
                    diamondRate: "",
                  }
                : item
            )
          );

          toastUpdate(
            "Error",
            "No details found for Caret Colour and Caret Grade combination",
            true
          );
        }
      } catch (error) {
        console.error("Error fetching diamond rate:", error);
        setDiamondRate([]);

        toastUpdate("Error", "Failed to fetch diamond rate", true);
      }
    };

    fetchDiamondRate();
  }, [
    groupDetailsCurrentObj?.caretColor,
    groupDetailsCurrentObj?.caretGrade,
    authToken,
    currentIndex,
  ]);

  const handleDiamondRate = (event, index) => {
    const value = event?.target?.value;
    const diamondValue = diamondRate?.[0];

    const isInvalid =
      Number(value) < Number(diamondValue?.minAmt) ||
      Number(value) > Number(diamondValue?.maxAmt);

    if (isInvalid) {
      toastUpdate(
        "Error",
        `Diamond rate should be between ${diamondValue?.minAmt} and ${diamondValue?.maxAmt}.`,
        true
      );
      setGroupDetails((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                diamondRate: "",
              }
            : item
        )
      );
    }
  };

  return (
    <div>
      {groupDetailsCurrentObj && (
        <Grid
          container
          spacing={2}
          key={currentIndex}
          className={classes.inputContainer}
        >
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Caret Grade*"
              value={groupDetailsCurrentObj?.caretGrade || ""}
              setState={(value) =>
                handleChange(
                  { target: { value, name: "caretGrade" } },
                  currentIndex
                )
              }
              data={CARAT_CLARITY_LIST.map((orn) => orn.name)}
              disabled={
                groupDetailsCurrentObj?.disabledField ||
                (isAuditFlagTrue
                  ? groupDetailsCurrentObj?.isOrnamentAudited
                  : checkValidationForNewPacket(currentIndex, "disabled"))
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Caret Color*"
              value={groupDetailsCurrentObj?.caretColor || ""}
              setState={(value) =>
                handleChange(
                  { target: { value, name: "caretColor" } },
                  currentIndex
                )
              }
              data={CARAT_COLOUR_LIST?.map((orn) => orn.name)}
              disabled={
                groupDetailsCurrentObj?.disabledField ||
                (isAuditFlagTrue
                  ? groupDetailsCurrentObj?.isOrnamentAudited
                  : checkValidationForNewPacket(currentIndex, "disabled"))
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <div style={{ position: "relative" }}>
              <CustomTextField
                label="Diamond Rate*"
                name="diamondRate"
                value={groupDetailsCurrentObj?.diamondRate || ""}
                disabled={
                  !groupDetailsCurrentObj?.caretColor ||
                  !groupDetailsCurrentObj?.caretGrade ||
                  groupDetailsCurrentObj?.disabledField ||
                  (isAuditFlagTrue
                    ? groupDetailsCurrentObj?.isOrnamentAudited
                    : checkValidationForNewPacket(currentIndex))
                }
                setState={(value) =>
                  handleChange(
                    { target: { name: "diamondRate", value } },
                    currentIndex
                  )
                }
                setIndexBlur={handleDiamondRate} // pass function directly
                index={currentIndex}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <div style={{ position: "relative" }}>
              <CustomTextField
                label="Diamond Caret*"
                value={groupDetailsCurrentObj?.diamondCaret || ""}
                disabled={
                  groupDetailsCurrentObj?.disabledField ||
                  (isAuditFlagTrue
                    ? groupDetailsCurrentObj?.isOrnamentAudited
                    : checkValidationForNewPacket(currentIndex))
                }
                setState={(value) =>
                  handleChange(
                    { target: { name: "diamondCaret", value } },
                    currentIndex
                  )
                }
                index={currentIndex}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Diamond Amount*"
              value={groupDetailsCurrentObj?.diamondAmount || ""}
              disabled
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

DiamondLoanField.propTypes = {
  classes: PropTypes.object,
  editable: PropTypes.bool,
};

export default DiamondLoanField;